import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords'
})
export class NumberToWordsPipe implements PipeTransform {

  private a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
    'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];

  private b = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  transform(value: number): string {
    if (value === null || value === undefined) return '';
    if (value === 0) return 'Zero rupees';

    const [integerPart, decimalPart] = value.toString().split('.');

    let result = this.convertNumberToWords(+integerPart) + ' rupees';

    if (decimalPart && +decimalPart > 0) {
      const paisa = decimalPart.substring(0, 2).split('').map(d => this.a[+d]).join(' ');
      result += ' and ' + paisa + ' paisa';
    }

    return result.trim();
  }

  private convertNumberToWords(num: number): string {
    if (num < 20) return this.a[num];
    if (num < 100) return this.b[Math.floor(num / 10)] + (num % 10 ? ' ' + this.a[num % 10] : '');
    if (num < 1000) return this.a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + this.convertNumberToWords(num % 100) : '');
    if (num < 100000) return this.convertNumberToWords(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + this.convertNumberToWords(num % 1000) : '');
    if (num < 10000000) return this.convertNumberToWords(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + this.convertNumberToWords(num % 100000) : '');
    return this.convertNumberToWords(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + this.convertNumberToWords(num % 10000000) : '');
  }
}
